import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=8018fa00&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=8018fa00&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8018fa00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8018fa00')) {
      api.createRecord('8018fa00', component.options)
    } else {
      api.reload('8018fa00', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=8018fa00&scoped=true", function () {
      api.rerender('8018fa00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/baseConfig/proportionalAllocation/edit.vue"
export default component.exports